module.exports = __webpack_public_path__ + "img/materialDelivery.3223d8fc.png";